const YapiRuhsat = resolve => {
    require.ensure(['../views/apps/yapiRuhsat/YapiRuhsat'], () => {
        resolve(require('../views/apps/yapiRuhsat/YapiRuhsat'))
    })
};
const YapiRuhsatTanimla = resolve => {
    require.ensure(['../views/apps/yapiRuhsat/YapiRuhsatTanimla'], () => {
        resolve(require('../views/apps/yapiRuhsat/YapiRuhsatTanimla'))
    })
};
const YapiRuhsatListesi = resolve => {
    require.ensure(['../views/apps/yapiRuhsat/YapiRuhsatListesi'], () => {
        resolve(require('../views/apps/yapiRuhsat/YapiRuhsatListesi'))
    })
};
const YapiRuhsatGuncelle = resolve => {
    require.ensure(['../views/apps/yapiRuhsat/YapiRuhsatGuncelle'], () => {
        resolve(require('../views/apps/yapiRuhsat/YapiRuhsatGuncelle'))
    })
};


import layouts from '../layout'
import Vue from 'vue'
Vue.component('yapiruhsat-tanimla', YapiRuhsatTanimla);
Vue.component('yapiruhsat-listesi', YapiRuhsatListesi);
Vue.component('yapiruhsat-guncelle', YapiRuhsatGuncelle);


export default {
    path: '/yapiruhsat',
    name: 'yapiruhsat',
    component: YapiRuhsat,
    meta: {
        layout: layouts.navLeft
    }

}